import React, { useState, useEffect, useMemo } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import HeadOfficePageList from "containers/headoffice/page/HeadOfficePageList";
import { get } from "aws-amplify/api";
import { createElementIdFactory } from "utils/elementIds";
import "containers/common/List.css";
import "containers/common/Table.css";
import 'containers/common/Detail.css';

const initial_filter = { name: "" };

function HeadOfficePageSearch({
  isAuthenticated,
  userPermissions, }) {

  const [name, setName] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [stateFilter, setStateFilter] = useState(initial_filter);
  const [headOffices, setHeadOffices] = useState([]);
  const hasTrustProof = userPermissions && userPermissions.trust_proof === true;
  const isReadyToRender = isAuthenticated && hasTrustProof;
  const createId = useMemo(() => createElementIdFactory("head-office-search"), []);

  useEffect(() => {
    if (!isAuthenticated) return;

    document.title = "Cityscope Head Office Search";
    setIsLoading(true);

    (async () => {
      const results = await getHeadOffices(stateFilter);
      setHeadOffices(results);
      setIsLoading(false);
    })();
  }, [isAuthenticated, stateFilter]);

  // --- Data Fetching and Update Functions ---
  async function getHeadOffices(filter) {
    try {
      const response = await get({
        apiName: "colin",
        path: "/headoffices",
        options: {
          queryParams: {
            name: filter.name
          }
        },
      }).response;

      return await response.body.json();
    } catch (error) {
      console.error("Fetch Failed:", error);
      return [];
    }
  }

  // --- Handlers ---
  function handleSubmit(event) {
    event.preventDefault();
    setIsLoading(true);
    setStateFilter({ name: name });
  }

  // --- Render Functions ---
  function renderHeadOffices() {
    return (
      <div className="HeadOffice">
        <Row className="show-Container mt-3">
          <Col sm={12} md={12} lg={12}>
            <h6>Cityscope Head Office Search</h6>

            <Form onSubmit={handleSubmit}>
              <Row>
                <Col lg={2}></Col>

                <Col lg={2}>
                  <Form.Group controlId={createId("name-input")} className="form-group">
                    <Form.Control
                      id={createId("name-input")}
                      name="name"
                      as="input"
                      type="text"
                      value={name}
                      onChange={e => setName(e.target.value)}
                      placeholder="Head Office Name containing"
                    />
                  </Form.Group>
                </Col>
                <Col lg={2}></Col>
                <Col>
                  <Button id={createId("search-btn")} type="submit">Search</Button>
                </Col>
              </Row>
            </Form>

            <div className="mt-3">
              <HeadOfficePageList
                data={headOffices || []}
                isLoading={isLoading}
                isAuthenticated={isAuthenticated}
                controlType="table"
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <>
      {isReadyToRender ? (
        renderHeadOffices()
      ) : (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          {isAuthenticated ? (
            <p>Checking permissions for {name}... If this persists, contact your admin.</p>
          ) : (
            <p>Please log in to access this page.</p>
          )}
        </div>
      )}
    </>
  );
}

export default HeadOfficePageSearch;